import React, { useCallback } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { SearchLink } from '../../../../../common/ui/search-link';
import {
	type EventWithTarget,
	type SearchDropdownElementProps,
	SearchLinkTypes,
} from '../../../../../common/ui/search-link/types';
import { onDropdownResultClicked } from '../../../../../common/utils/events/dropdown-result-clicked';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../../../../controllers/analytics';
import {
	useDropdownActions,
	useRecentViewsResults,
	useResultCount,
} from '../../../../../controllers/store/dropdown';

const iconStyles = xcss({
	width: '24px',
	height: '24px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const RecentViews = ({ getElementIndex }: SearchDropdownElementProps): React.JSX.Element => {
	const [recentViewsResults] = useRecentViewsResults();
	const { setShowDropdown } = useDropdownActions();
	const [resultCount] = useResultCount();

	const { fireAnalyticsEvent } = useAnalytics();
	const { commonAttributes, nonPrivacySafeAttributes } = useCommonAndPrivateAttributes();

	const fireAnalytics = useCallback(
		(event: EventWithTarget) => {
			const index = event.target && getElementIndex ? getElementIndex(event.target) : undefined;

			fireAnalyticsEvent(
				onDropdownResultClicked({
					commonAttributes,
					nonPrivacySafeAttributes,
					resultType: SearchLinkTypes.RecentViews,
					...(index !== undefined ? { index } : {}),
				}),
			);
		},

		[getElementIndex, fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes],
	);

	const onClick = (event: EventWithTarget) => {
		setShowDropdown(false);
		fireAnalytics(event);
	};

	return (
		<>
			{recentViewsResults?.slice(0, resultCount.recentViews).map((result, index) => {
				return (
					<SearchLink
						title={result.title}
						description={result.description}
						subheading={result.subheading}
						icon={<Box xcss={iconStyles}>{result.icon}</Box>}
						onClick={onClick}
						highlightedTitle={result.highlightedTitle}
						key={`${index}-${result.title}`}
						navigationUrl={result.navigationUrl}
					/>
				);
			})}
		</>
	);
};
